import React from "react";
import { MessageItemView } from "./view";
import { styles } from "./styles";

export class MessageItem extends React.Component {
  render() {
    return <MessageItemView {...this.props} styles={styles} />;
  }
}
